/*-----product details show more toggler-----*/
const togglerTarget = document.getElementById("more-info-togglar");
if (togglerTarget) {
  togglerTarget.addEventListener("click", showMoreToggler);
}

function showMoreToggler() {
  this.classList.toggle("active");
  document
    .getElementById("product-more-info-wrapper")
    .classList.toggle("active");
}

/*-----------------------
Producer details magnifying zoom effect
-----------------------*/
// Get the necessary elements
const imageContainer = document.querySelector(".map-image-container");
const zoomBox = document.querySelector("#map-zoom-box");
const zoomImage = document.querySelector("#map-zoom-image");
let zoomFactor;

// Calculate the zoom factor based on the size of the zoom box and the original image
if (zoomBox || zoomImage) {
  zoomFactor = zoomImage.offsetWidth / zoomBox.offsetWidth;
}

// Add event listeners for mouse movement
if (imageContainer) {
  imageContainer.addEventListener("mousemove", handleMouseMove);
  imageContainer.addEventListener("mouseenter", showZoomBox);
  imageContainer.addEventListener("mouseleave", hideZoomBox);
}

// Function to handle mouse movement
function handleMouseMove(event) {
  const { offsetX, offsetY } = event;

  // Calculate the position of the zoom box
  const zoomBoxX = offsetX - zoomBox.offsetWidth / 2;
  const zoomBoxY = offsetY - zoomBox.offsetHeight / 2;

  // Move the zoom box
  zoomBox.style.left = `${zoomBoxX}px`;
  zoomBox.style.top = `${zoomBoxY}px`;

  // Calculate the position of the background image within the zoom box
  const zoomImageX = -(zoomBoxX * zoomFactor);
  const zoomImageY = -(zoomBoxY * zoomFactor);

  zoomBox.style.backgroundSize = `${zoomImage.offsetWidth * zoomFactor}px ${
    zoomImage.offsetHeight * zoomFactor
  }px`;
  zoomBox.style.backgroundPosition = `${zoomImageX}px ${zoomImageY}px`;
}

// Function to show the zoom box
function showZoomBox() {
  zoomBox.style.display = "block";
  zoomBox.style.visibility = "visible";
  zoomBox.style.opacity = "1";
}

// Function to hide the zoom box
function hideZoomBox() {
  zoomBox.style.display = "none";
  zoomBox.style.visibility = "hidden";
  zoomBox.style.opacity = "0";
}

if (!customElements.get('truncated-description')) {
  customElements.define(
    'truncated-description',
    class TruncatedDescription extends HTMLElement {
      constructor() {
        super()
        this.button = this.querySelector('[data-reveal-button]')
        this.truncated = this.querySelector('[data-truncated]')
        this.full = this.querySelector('[data-full]')
        this.init()
      }
      init() {
        this.button.addEventListener('click', this.expandDescription.bind(this))
      }
      expandDescription(e) {
        e.preventDefault();
        this.classList.toggle('active');
      }
    }
  )
}
